import { goBack } from "assets/icons";
import styled from "@emotion/styled";
import { Affix, Button, Card, Col, Row, Tabs, Typography } from "antd";
import { useState, useEffect } from "react";
import AgentList from "./AgentList";
import { useNavigate, useLocation } from "react-router-dom";
import { useLoadContactsList } from "hooks/useAgents";
import RetailList from "../ManageRetail/RetailList";
import { useAppSelector } from "store";

const ManageAgent = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const fromDetail = location.state?.fromDetail === true;
  //agent list
  const [search, setSearch] = useState<string>('');
  const [currentPage, setCurrentPage] = useState<number>(() => {
    if (!fromDetail) return 1;
    try {
      const saved = JSON.parse(sessionStorage.getItem("manage_agent_list_session") || "{}");
      return saved.currentPage ?? 1;
    } catch { return 1; }
  });
  const { contact } = useAppSelector((state) => state.auth);
  const itemsPerPage = 9; // จำนวนรายการต่อหน้า
  const startIndex = (currentPage - 1) * itemsPerPage;
  const endIndex = currentPage * itemsPerPage;
  const { data: dataRetail, isLoading: isLoadingRetail, refetch: refetchRetail }= useLoadContactsList(
    {
      ref_type: "retail",
      offset: startIndex,
      limit: endIndex,
      sort_by: "asc",
      search: search,
    }
  )

  const [searchAgent, setSearchAgent] = useState<string>('');
  const [currentPageAgent, setCurrentPageAgent] = useState<number>(() => {
    if (!fromDetail) return 1;
    try {
      const saved = JSON.parse(sessionStorage.getItem("manage_agent_list_session") || "{}");
      return saved.currentPageAgent ?? 1;
    } catch { return 1; }
  });
  const [activeTabKey, setActiveTabKey] = useState<string>(() => {
    if (!fromDetail) return '0';
    try {
      const saved = JSON.parse(sessionStorage.getItem("manage_agent_list_session") || "{}");
      return saved.activeTabKey ?? '0';
    } catch { return '0'; }
  });
  const itemsPerPageAgent = 9; // จำนวนรายการต่อหน้า
  const startIndexAgent = (currentPageAgent - 1) * itemsPerPageAgent;
  const { data: dataAgent, isLoading: isLoadingAgent, refetch: refetchAgent }= useLoadContactsList(
    {
      ref_type: "agent",
      offset: startIndexAgent,
      limit: itemsPerPageAgent,
      sort_by: "asc",
      search: searchAgent,
    }
  )

  const items = [
    ...(contact?.code === "lunganek" ? [
    {
      label: `ลูกค้า (${dataRetail?.data?.total_record || 0})`,
      key: "0",
      children: 
        <>
          <RetailList
            data={dataRetail}
            isLoading={isLoadingRetail}
            currentPage={currentPage}
            setCurrentPage={setCurrentPage}
            itemsPerPage={itemsPerPage}
            setSearch={setSearch}
            refetch={refetchRetail} 
          />
          <Affix offsetBottom={0}>
            <WrapperAll>
              <ButtonWrapper>
                <Button
                  onClick={() => {
                    navigate("/manage-agent/create-retail");
                  }} 
                  type="primary"
                  style={{ width: 200 }}
                size="large"
                >
                  เพิ่มลูกค้าใหม่
                </Button>
              </ButtonWrapper>
            </WrapperAll>
          </Affix>
        </>
        ,
    },
    ] : []),
    {
      label: ` ${contact?.code === "lunganek" ? "ตัวแทน" : "ลูกค้า"} (${dataAgent?.data?.total_record || 0})`,
      key: "1",
      children: 
        <><AgentList
          data={dataAgent}
          isLoading={isLoadingAgent}
          currentPage={currentPageAgent}
          setCurrentPage={setCurrentPageAgent}
          itemsPerPage={itemsPerPageAgent}
          setSearch={setSearchAgent}
          refetch={refetchAgent} />
          {/* <Affix offsetBottom={0}>
            <WrapperAll>
              <ButtonWrapper>
                <Button
                  onClick={() => {
                    navigate("/manage-agent/create-agent");
                  } }
                  type="primary"
                  style={{ width: 200 }}
                  size="large"
                >
                  เพิ่มตัวแทนใหม่
                </Button>
              </ButtonWrapper>
            </WrapperAll>
          </Affix> */}
        </>
        ,
    },
  ];

  useEffect(() => {
    sessionStorage.setItem("manage_agent_list_session", JSON.stringify({
      activeTabKey,
      currentPage,
      currentPageAgent,
    }));
  }, [activeTabKey, currentPage, currentPageAgent]);

  const [showSearch, setShowSearch] = useState(false);
  return (
    <>
      <Card bordered={false} className="criclebox h-full tabs-mobile">
        <HeaderTabs>
          <IconWrapper onClick={() => {
            navigate("/dashboard");
          }}>
            <SpanIcon>{goBack}</SpanIcon>
          </IconWrapper>
          {showSearch ? null : (
            <>
              <Typography.Title level={5}>{contact?.code === "lunganek" ? "ลูกค้า/ตัวแทน" : "ฐานลูกค้า"}</Typography.Title>
            </>
          )}
          <RightIconWrapper>
      
          </RightIconWrapper>
        </HeaderTabs>
        
        <Row className="rowgap-vbox" gutter={[24, 0]}>
          <Col sm={24} md={24}>
            <Tabs
              activeKey={items.some(item => item.key === activeTabKey) ? activeTabKey : (items[0]?.key ?? '0')}
              onChange={setActiveTabKey}
              style={{ height: "100%" }}
              items={items}
              key="key"
            />
          </Col>
        </Row>
      </Card>
    </>
  );
};

export default ManageAgent;

const HeaderTabs = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px;
  flex-direction: row;
  border-bottom: 1px solid #efefef;
`;

const IconWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 30px;
  border-radius: 6px;
  background-color: #ffffff;
  cursor: pointer;
  transition: all 0.3s ease-in-out;
  &:hover {
    background-color: #efefef;
  }
`;

const SpanIcon = styled.span`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
`;

const RightIconWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
`;

const WrapperAll = styled.div`
  display: block;
  width: 100%;
  background-color:white;
  overflow-y: auto;
  overflow-x: hidden;
  padding: 5px;
`;
const ButtonWrapper = styled.div`
  max-width: 250px;
  margin: 0 auto;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
`;

